import { motion } from "framer-motion";

const HERO_BG = "https://customer-assets.emergentagent.com/job_villa-surveillance/artifacts/ghbrcb7b_Piscine%20palmier.png";

export default function Hero() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="accueil" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#2E3A34]/50" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="text-5xl sm:text-6xl lg:text-7xl text-white tracking-[0.08em] mb-6"
          style={{ fontFamily: "'Cinzel', serif", fontWeight: 400 }}
          data-testid="hero-title"
        >
          AŪRA HOME CARE
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
          className="text-xl sm:text-2xl lg:text-3xl text-white/90 mb-12 max-w-3xl italic"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
          data-testid="hero-subtitle"
        >
          La sérénité de votre maison, même en votre absence
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
          className="flex flex-col sm:flex-row gap-4 sm:gap-6"
        >
          <button
            onClick={() => scrollTo("#offres")}
            data-testid="hero-cta-offres"
            className="bg-[#b39a73] text-white px-10 py-4 text-sm tracking-[0.2em] uppercase hover:bg-[#b8a68c] transition-all duration-300"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          >
            Découvrir nos offres
          </button>
          <button
            onClick={() => scrollTo("#coordonnees")}
            data-testid="hero-cta-contact"
            className="border border-[#b39a73] text-[#b39a73] px-10 py-4 text-sm tracking-[0.2em] uppercase hover:bg-[#b39a73]/10 transition-all duration-300"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          >
            Nous contacter
          </button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="w-[1px] h-12 bg-white/40 mx-auto mb-2" />
      </motion.div>
    </section>
  );
}
